module.exports = __webpack_public_path__ + "components/weather-icon/static/nightpartcloud@3-5669e2d1bc9c814b745eba2090dcc355.png";